import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { CreateDestinationInput, Destination } from '@ui/__generated__/graphql'
import { NameInput } from '@ui/components/core/NameInput'
import { showToast } from '@ui/components/elements/ToastManager'
import { DynamicFormValues } from '@ui/interfaces'
import { CreateDestinationQuery } from '@ui/loaders/destinations'
import { ExporterForm } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/ExporterForm'
import { ExporterTiles } from '@ui/pages/pipelinesWorkflow/components/Export/ExporterTiles'
import { useExporterNodeStore } from '@ui/stores'

type DestinationFormProps = {
  onCreate: (destination: Destination) => void
  onCancel: () => void
}

export const DestinationForm = ({ onCancel, onCreate }: DestinationFormProps) => {
  const [name, setName] = useState('')

  const [createDestination, { loading, error }] = CreateDestinationQuery()

  const { template, setTemplate, setWizardStep } = useExporterNodeStore(
    useShallow((state) => ({
      template: state.template,
      setTemplate: state.setTemplate,
      setWizardStep: state.setWizardStep,
    }))
  )

  const saveDestination = async (formData: DynamicFormValues) => {
    if (loading || !template) return

    const input: CreateDestinationInput = {
      name,
      formData,
      sliceTemplateId: template.id,
    }

    const { data } = await createDestination({ variables: { input } })

    showToast.success('Destination has been created')

    setTemplate(null)
    setWizardStep(0)

    onCreate(data.createDestination)
  }

  useEffect(() => {
    if (error) {
      showToast.error('Failed to create destination')
    }
  }, [error])

  useEffect(() => {
    // reset new destination template selection on revisiting
    setTemplate(null)
  }, [setTemplate])

  return (
    <div className="h-full w-full">
      {template ? (
        <ExporterForm
          cancel={onCancel}
          saveConfig={saveDestination}
          template={template}
          config={{}}
          additionalInputs={<NameInput onChange={setName} value={name} />}
        />
      ) : (
        <ExporterTiles cancel={onCancel} />
      )}
    </div>
  )
}
